import { render, staticRenderFns } from "./codeInput.vue?vue&type=template&id=0471a7a0"
import script from "./codeInput.vue?vue&type=script&lang=js"
export * from "./codeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports